module.exports = __webpack_public_path__ + "static/tools-d6971b4ba153b1f89e3ecb28c6d61e29.svg";